import { cn } from "@/lib/utils";

interface ChevronProps {
    color?: string;
    size?: number;
    onClick?: () => void;
}

export const ChevronDown: React.FC<ChevronProps> = ({
    color = "text-black",
    size = 7,
    onClick = () => { },
}) => {
    return (
        <svg
            width={size}
            height={(size * 4) / 7} // Maintain aspect ratio
            viewBox="0 0 7 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn("transition-transform duration-200 ease-in-out fill-current", color)}
            onClick={onClick}
        >
            <path
                d="M6.80358 0.186209C6.67916 0.0669431 6.51086 0 6.33543 0C6.16 0 5.9917 0.0669431 5.86729 0.186209L3.4834 2.45305L1.13271 0.186209C1.0083 0.0669431 0.839995 0 0.664566 0C0.489137 0 0.320836 0.0669431 0.196421 0.186209C0.134182 0.245738 0.084781 0.316561 0.0510688 0.394593C0.0173566 0.472626 0 0.556323 0 0.640857C0 0.72539 0.0173566 0.809088 0.0510688 0.88712C0.084781 0.965153 0.134182 1.03598 0.196421 1.0955L3.01193 3.81059C3.07366 3.8706 3.14711 3.91824 3.22803 3.95075C3.30894 3.98326 3.39574 4 3.4834 4C3.57106 4 3.65785 3.98326 3.73877 3.95075C3.81969 3.91824 3.89313 3.8706 3.95486 3.81059L6.80358 1.0955C6.86582 1.03598 6.91522 0.965153 6.94893 0.88712C6.98264 0.809088 7 0.72539 7 0.640857C7 0.556323 6.98264 0.472626 6.94893 0.394593C6.91522 0.316561 6.86582 0.245738 6.80358 0.186209Z"
            />
        </svg>
    );
};

export const ChevronUp: React.FC<ChevronProps> = ({
    color = "text-black",
    size = 7,
    onClick = () => { },
}) => {
    return (
        <svg
            width={size}
            height={(size * 4) / 7}
            viewBox="0 0 7 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn("transition-transform duration-200 ease-in-out fill-current", color)}
            onClick={onClick}
        >
            <path
                d="M0.196422 3.81379C0.320837 3.93306 0.489138 4 0.664567 4C0.839995 4 1.0083 3.93306 1.13271 3.81379L3.5166 1.54695L5.86729 3.81379C5.9917 3.93306 6.16001 4 6.33543 4C6.51086 4 6.67916 3.93306 6.80358 3.81379C6.86582 3.75426 6.91522 3.68344 6.94893 3.60541C6.98264 3.52737 7 3.44368 7 3.35914C7 3.27461 6.98264 3.19091 6.94893 3.11288C6.91522 3.03485 6.86582 2.96402 6.80358 2.9045L3.98807 0.189414C3.92634 0.129395 3.85289 0.0817568 3.77197 0.049247C3.69106 0.0167374 3.60426 -2.96865e-07 3.5166 -3.04528e-07C3.42894 -3.12192e-07 3.34215 0.0167374 3.26123 0.0492469C3.18031 0.0817567 3.10687 0.129395 3.04514 0.189414L0.196422 2.90449C0.134183 2.96402 0.0847822 3.03485 0.0510698 3.11288C0.0173579 3.19091 6.34157e-08 3.27461 5.60255e-08 3.35914C4.86353e-08 3.44368 0.0173579 3.52737 0.0510698 3.60541C0.0847822 3.68344 0.134182 3.75426 0.196422 3.81379Z"
            />
        </svg>
    );
};

export const ChevronRight: React.FC<ChevronProps> = ({
    color = "black",
    size = 7,
    onClick = () => {},
  }) => {
    return (
      <svg
        width={(size * 4) / 7} // maintain aspect ratio horizontally
        height={size}
        viewBox="0 0 4 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="transition-transform duration-200 ease-in-out"
        onClick={onClick}
      >
        <path
          d="M0.186209 0.196422C0.0669431 0.320837 0 0.489138 0 0.664567C0 0.839995 0.0669431 1.0083 0.186209 1.13271L2.45305 3.5166L0.186209 5.86729C0.0669431 5.9917 0 6.16001 0 6.33543C0 6.51086 0.0669431 6.67916 0.186209 6.80358C0.245738 6.86582 0.316561 6.91522 0.394593 6.94893C0.472626 6.98264 0.556323 7 0.640857 7C0.72539 7 0.809088 6.98264 0.88712 6.94893C0.965153 6.91522 1.03598 6.86582 1.0955 6.80358L3.81059 3.98807C3.8706 3.92634 3.91824 3.85289 3.95075 3.77197C3.98326 3.69106 4 3.60426 4 3.5166C4 3.42894 3.98326 3.34215 3.95075 3.26123C3.91824 3.18031 3.8706 3.10687 3.81059 3.04514L1.0955 0.196422C1.03598 0.134183 0.965153 0.0847822 0.88712 0.0510698C0.809088 0.0173579 0.72539 6.34157e-08 0.640857 5.60255e-08C0.556323 4.86353e-08 0.472626 0.0173579 0.394593 0.0510698C0.316561 0.0847822 0.245738 0.134182 0.186209 0.196422Z"
          fill={color}
        />
      </svg>
    );
  };
